import * as ReselectModule from "reselect";
import { IClientActionListState } from ".";
import { IApplicationState } from "..";

export const selectClientActionList: ReselectModule.Selector<
  IApplicationState,
  IClientActionListState
> = (state) => state.clientActionList;
